import { ViewProperties } from "../../../utils/ViewProperties";
import { GameStyle } from "../style/GameStyle";
/**
 * Game-specific properties for the free spins overlay.
 */
export class GameFreeSpinsOverlayProperties extends ViewProperties {
    constructor() {
        super(...arguments);
        this.isDebug = false; //Todo: this can be removed when the game is near-final.
        this.dabTrailGlowDistance = GameStyle.FREE_SPIN_TRAIL_GLOW.distance;
        this.dabTrailGlowStrength = GameStyle.FREE_SPIN_TRAIL_GLOW.strength;
        this.dabTrailColours = GameStyle.FREE_SPIN_TRAIL_GLOW.colours;
    }
}
//# sourceMappingURL=GameFreeSpinsOverlayProperties.js.map